import { axiosClient } from '@services/clients'

// Allowed filter keys for GET /fee-configurations
const FEE_CONFIG_FILTER_KEYS = [
  'brand_id',
  'payment_method_name',
  'transaction_type',
  'is_active',
]

export async function getPaymentCharges(filters = {}) {
  const params = {}
  FEE_CONFIG_FILTER_KEYS.forEach((key) => {
    if (
      filters[key] !== '' &&
      filters[key] !== undefined &&
      filters[key] !== null
    ) {
      params[key] = filters[key]
    }
  })
  const { data } = await axiosClient(
    `/fee-configurations?${new URLSearchParams(params).toString()}`,
  )
  return data
}

export async function getPaymentCharge(id) {
  const { data } = await axiosClient(`/fee-configurations/${id}`)
  return data
}

export async function createPaymentCharge(payload) {
  const { data } = await axiosClient.post('/fee-configurations', payload)
  return data
}

export async function updatePaymentCharge(id, payload) {
  const { data } = await axiosClient.put(`/fee-configurations/${id}`, payload)
  return data
}

export async function toggleFeeConfigState(id, isActive) {
  const { data } = await axiosClient.patch(`/fee-configurations/${id}/state`, {
    is_active: isActive,
  })
  return data
}

export async function getPaymentProviders() {
  const {
    data: { result },
  } = await axiosClient('/payment-methods')
  return result
}
